import * as React from "react";

const Disclaimer = () => {

  return (
    <>
      <div className="disclaimer-card" style={{ margin: '20px auto' }}>
        <h2>Terms and Conditions</h2>

        <p>
          By using the software, you agree to the Terms and Conditions below.
        </p>

        <h2>No Attorney-Client Relationship</h2>

        <p>
          The software is general informational purposes only and do not constitute advertising, a solicitation or legal advice. Neither the availability, operation, transmission, receipt nor use of the software is intended to create, or constitutes formation of, an attorney-client relationship or any other special relationship or privilege. You should not rely upon the output for any purpose without seeking legal advice from licensed attorneys in the relevant state(s).
        </p>

        <h2>Privacy Matters</h2>

        <p>
          As part of the normal operation of the underlying software, the software temporarily stores information that you have entered so that the software can operate as designed. By using the software, you confirm that you have authority to share any information that you furnish. We disclaim any and all liability in connection with the collection, use or disclosure of the information furnished by you or otherwise collected by the software. Please note that we cannot guarantee the security of any information transmitted to us over the internet. Please also refer to the Privacy Policy.
        </p>

        <h2>Compliance with Laws</h2>

        <p>
          You agree to use the software in compliance with all applicable laws, including applicable securities laws, and you agree to indemnify and hold the owner of the site harmless from and against any and all claims, damages, losses, or obligations arising from your failure to comply.
        </p>

        <h2>Disclaimer of Liability</h2>

        <p>
          THE SOFTWARE AND ANY INFORMATION ARE PROVIDED AS-IS WITH NO REPRESENTATIONS OR WARRANTIES, EITHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NONINFRINGEMENT. YOU ASSUME COMPLETE RESPONSIBILITY AND RISK FOR USE OF THE SOFTWARE. Some jurisdictions do not allow the exclusion of implied warranties, so the above exclusion may not apply to you.
        </p>

        <p>
          The owner and publisher of the software expressly disclaims all liability, loss or risk incurred as a direct or indirect consequence of the use of the software. By using the software, you waive any rights or claims you may have against Wilson Sonsini in connection therewith. The information generated by the software is provided only as general information and may not reflect the most current market and legal developments and may not address all relevant business or legal issues; accordingly, information provided by the software is not promised or guaranteed to be correct or complete. Further, the site does not necessarily endorse, and is not responsible for, any third-party content that may be accessed through the software.
        </p>

        <p>
          The site at its sole discretion may choose to change the terms, conditions, and operation of the software at any time. The site, in its sole discretion, reserves the right to refuse to provide you access to the software and you agree that the site shall not be liable to you for loss or damages that may result from our refusal to provide access to the software herein.
        </p>

        <h2>Use by Agents</h2>

        <p>
          You agree that, if an agent (e.g., an attorney, an employee, etc.) uses the software on your behalf, you are nonetheless bound as a principal by all terms and conditions herein.
        </p>
      </div>
    </>
  )
}

export default Disclaimer